import ReactDOM from "react-dom";

import { EuModalService, ModalConfig } from "easyui-core";
import React from "react";
import { ModalComponent } from "./ModalComponent";
import { ModalChildProps } from "./ModalChildProps";

class AntModalService extends EuModalService {

    openConfirm(modalOptions: ModalConfig, success?: Function | undefined, dismiss?: Function | undefined) {
        throw new Error("Method not implemented.");
    }

    open(config: ModalConfig & {
        visible: boolean,
        afterClose: Function
    }, success?: Function | undefined, dismiss?: Function | undefined) {
        const div = document.createElement('div');
        document.body.appendChild(div);

        const onClose = (...args: any[]) => {
            // currentConfig = {
            //     ...currentConfig,
            //     visible: false,
            //     afterClose: destroy.bind(this, ...args),
            // };
            // render(currentConfig);
        }

        const onDismiss = (...args: any[]) => {
            // currentConfig = {
            //     ...currentConfig,
            //     visible: false,
            //     afterClose: destroy.bind(this, ...args),
            // };
            // render(currentConfig);
        }

        function update(newConfig: ModalConfig) {
            currentConfig = {
                ...currentConfig,
                ...newConfig,
            };
            render(currentConfig);
        }

        function destroy(...args: any[]) {
            const unmountResult = ReactDOM.unmountComponentAtNode(div);
            if (unmountResult && div.parentNode) {
                div.parentNode.removeChild(div);
            }
            const triggerCancel = args.some(param => param && param.triggerCancel);
            // if (config.onCancel && triggerCancel) {
            //     config.onCancel(...args);
            // }
            // for (let i = 0; i < destroyFns.length; i++) {
            //     const fn = destroyFns[i];
            //     if (fn === close) {
            //         destroyFns.splice(i, 1);
            //         break;
            //     }
            // }
        }

        function render(props: any) {
            ReactDOM.render(<ModalComponent {...props} ></ModalComponent>, div);
        }

        let currentConfig = {
            ...config,
            onOk: success,
            onDismiss: dismiss,
            afterClose: destroy.bind(this),
            visible: true,
        } as any;
        render(currentConfig);
    }

    destroy() {
        throw new Error("Method not implemented.");
    }



}
const ModalService = new AntModalService();
export { ModalService }